import React from "react";

function AboutMePage() {
  return (
    <div className="AboutMe">
      <h3>Hello! I'm Laura, and I build web apps and tools.</h3>
      <p>
        I mostly do front-end design and development, and I love bridging the gap between design and technical solutions.
        My foundation is in JavaScript and related libraries like React, as well as CSS and SCSS.
        I also like playing with databases, so I've learned PHP, MySQL, and even a little
        Python and Bash. 
        When I'm not coding, I'm probably out taking foster dogs on hikes, sewing,
        or reading.
      </p>
      <a
        href="https://www.linkedin.com/in/laura-brown-898b8a52/"
        target="_blank"
        rel="noreferrer"
      >
        <button>Let's connect on LinkedIn!</button>
      </a>
    </div>
  );
}

export default AboutMePage;
